import React, { Component } from 'react';
import LoginApiHandler from './../LoginApiHandler.js';
import logo from './../../../assets/img/logo.png'
import GoogleLogin from 'react-google-login';
import CircularProgress from '@material-ui/core/CircularProgress';

export default class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loader: false,
			errorText: null
		}
		this.loginWithGoogle = this.loginWithGoogle.bind(this);
		this.failedFetchingToken = this.failedFetchingToken.bind(this);
		this.loginComplete = this.loginComplete.bind(this);
	}

	loginComplete(user) {
		localStorage.setItem('user', JSON.stringify(user));
		localStorage.setItem('isLoggedIn', true);
		window.location.assign('/');
		//window.location.reload();
	}

	loginWithGoogle(response) {
		this.setState({ loader: true });
		var token = response.tokenId;
		LoginApiHandler.loginWithToken(token)
			.then(function (resp) {
				this.loginComplete(resp);
			}.bind(this)).catch(function (error) {
				this.setState({ errorText: error.error.error });
			}.bind(this)).finally(function () {
				this.setState({ loader: false });
			}.bind(this))
	}

	failedFetchingToken(response) {
		console.log(response);
	}

	render() {
		return (
			<div className="login-wrapper">
				<div className="login-box">
					<div className="logo">
						<img src={logo} alt="Bradman" />
					</div>
					<div className="login-button">
						<GoogleLogin
							clientId="440771939373-urtguu08tofvsjmglcfa7uqqspqnm7hg.apps.googleusercontent.com"
							buttonText="Login with Google"
							onSuccess={this.loginWithGoogle}
							onFailure={this.failedFetchingToken}
							style={{ padding: '5px 90px', color: '#212121', backgroundColor: '#d8d8d8', fontSize: '18px', outline: 'none' }}
						/>
					</div>
					<div style={{ height: '30px', marginTop: '10px' }}>
						{(this.state.loader) ? <div><CircularProgress size={18} thickness={5} style={{ color: '#fff' }} /></div> : null}
					</div>
					<div className="support-message">
						Please Contact Us at <a href="mailto:product-support@jumbotail.com" className="tech-id">product-support@jumbotail.com</a>
					</div>
					<div style={{ color: 'brown', marginTop: '20px' }}>{this.state.errorText}</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/screens/Login/Components/Login.js